/* What a filing covers of its group: the choice, beside the notice that names who is left out. Tokens
   only (ADR-0007); the notice's own rule and measure come from Reports.module.css. */

.form {
  display: grid;
  gap: 8px;
  margin: 0 0 10px;
  max-width: 92ch;
}

.fieldset {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
  margin: 0;
  padding: 0;
  border: 0;
}

.legend {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 4px;
  padding: 0;
  font-size: var(--t-min);
  font-weight: 650;
  color: var(--ink);
}

.option {
  display: inline-flex;
  gap: 6px;
  align-items: center;
  font-size: var(--t-min);
  color: var(--ink);
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.confirm {
  display: flex;
  gap: 6px;
  align-items: flex-start;
  font-size: var(--t-min);
  color: var(--ink-2);
}

.settled {
  margin: 0;
  font-size: var(--t-min);
  color: var(--ink-2);
}

.refusal {
  margin: 0;
  font-size: var(--t-min);
  color: var(--ink);
}
